import axios from "axios";




function registeraccount(email)
{
    logger.log('registeraccount wsj POST!! : ' + email);

    var data = new FormData();
    data.append('email', email);
    
    axios.post("/api/registerwsj/ajax", data).then(response => {
 
        //console.log(response.data);
        var password = response.data;
        if (password != "0") 
        {
            // login

            var data = new FormData();
            data.append('email', email);
            data.append('password', password);

            axios.post("/api/loginwsj/ajax", data).then(response => {
            
                console.log('login response :' + response.data);
                if(response.data == "0") {
                    $(".loader-container").remove();
                    $("#emailError").html("Error account login");
                }
                else {
                    document.location = "/billing";
                }
            });
        }
        else
        {
            $(".loader-container").remove();
            $("#emailError").html("Error account already exists!");
        }
    });

    /*
    $.post('/registerwsj/ajax', {email: email}, function(password)
    {
        if (password != null) 
        {
            $.post('/login/ajax', {login: email, password : password}, function(data)
            {
                console.log(data);
                
                if (data == "Success") {

                    document.location = "/wsjpass";

                }
                else
                {

                    $(".loader-container").remove();
                    $("#emailError").html(data);
                    $('.entry-error-message').css("color", "red");
                    //$('#emailInput').css("background-color", "background-color: rgba(255,0,0,.2)");
                    //$('#passwordInput').css("background-color", "background-color: rgba(255,0,0,.2)");
                    return;
                }
            });
            
        }
        else {
            $(".loader-container").remove();
            $("#emailError").html("password error");
        }
    });*/
}

$(document).ready(function ()
{
    logger.log('ready wsj!!');

   
    Object.size = function(obj) {
            var size = 0, key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) size++;
            }
            return size;
        };

    $("#btnStart").on('click', function() {

        $("<div class='loader-container'>"+
            "<div class='container-1'>"+
              "<div class='item-1'><span></span></div>"+
              "<div class='item-2'><span></span></div>"+
              "<div class='item-3'><span></span></div>"+
              "<div class='item-4'><span></span></div>"+
              "<div class='item-5'><span></span></div>"+
            "</div>"+
          "</div>").prependTo("#signup");

        var email = $('#emailInput').val();

        var errors = [];

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(email)) {
            $(".loader-container").remove();
            $('#emailInput').css("border", "solid 1px red");
            errors['email'] = "Your email is invalid, enter a valid email to continue";
        }
        else {
            $('#emailInput').css("border", "solid 1px green");
             $("#emailError").html("");
        }

        if (Object.size(errors) == 0) {
            registeraccount(email);
        }
        else {
            $(".loader-container").remove();
            $("#emailError").html(errors["email"]);
        }

    });
});
